export const addNewOrder = () => {
  //console.log('ACTION addNewOrder');
  // Return action
  return {
    // Unique identifier
    type: 'ADD_NEW_ORDER',
    // Payload
  }
};

export const resetProject = () => {
	//console.log('ACTION Reset');
  // Return action
  return {
    // Unique identifier
    type: 'RESET_PROJECT',
    // Payload
  }
};

export const updateComment = (id, comment) => {
	//console.log('ACTION updateComment ['+id+']: '+comment);
  // Return action
  return {
    // Unique identifier
    type: 'UPDATE_COMMENT',
    // Payload
	id: id,
	comment: comment
  }
};
export const updateReference = (id, reference) => {
	//console.log('ACTION updateReference ['+id+']: '+reference);
  // Return action
  return {
    // Unique identifier
    type: 'UPDATE_REFERENCE',
    // Payload
	id: id,
	reference: reference
  }
};

export const updateDocument = (id, doc) => {
	//console.log('ACTION updateDocument ['+id+']: '+doc);
  // Return action
  return {
    // Unique identifier
    type: 'UPDATE_DOCUMENT',
    // Payload
	id: id,
	doc: doc
  }
};

export const updateAttachment = (id, doc) => {
	//console.log('ACTION updateAttachment ['+id+']: '+doc);
  // Return action
  return {
    // Unique identifier
    type: 'UPDATE_ATTACHMENT',
    // Payload
	id: id,
	doc: doc
  }
};

export const updateTask = (id, task, checked) => {
	//console.log('ACTION updateTask ['+id+'] ['+task+']: '+checked);
  // Return action
  return {
    // Unique identifier
    type: 'UPDATE_TASK',
    // Payload
	id: id,
	task: task,
	checked: checked
  }
};

export const updateLang = (id, lang, checked) => {
	//console.log('ACTION updateLang ['+id+'] ['+lang+']: '+checked);
  // Return action
  return {
    // Unique identifier
    type: 'UPDATE_LANG',
    // Payload
	id: id,
	product: lang,
	checked: checked
  }
};

export const updateLP = (id, task, idLP, checked) => {
	//console.log('ACTION updateLP ['+id+'] ['+task+'] ['+idLP+']: '+checked);
  // Return action
  return {
    // Unique identifier
    type: 'UPDATE_LP',
    // Payload
	id: id,
	task: task,
	idLP: idLP,
	checked: checked
  }
};

export const updateUrgent = (id, checked) => {
	//console.log('ACTION updateUrgent: '+checked);
  // Return action
  return {
    // Unique identifier
    type: 'UPDATE_URGENT',
    // Payload
	id: id,
	checked: checked
  }
};

export const updateSpecial = (id, checked) => {
	//console.log('ACTION updateSpecial: '+checked);
  // Return action
  return {
    // Unique identifier
    type: 'UPDATE_SPECIAL',
    // Payload
	id: id,
	checked: checked
  }
};

export const updateAlert = (id, checked) => {
	//console.log('ACTION updateSpecial: '+checked);
  // Return action
  return {
    // Unique identifier
    type: 'UPDATE_ALERT',
    // Payload
	id: id,
	checked: checked
  }
};


export const updateQuotation = (id, checked) => {
	//console.log('ACTION updateQuotation: '+checked);
  // Return action
  return {
    // Unique identifier
    type: 'UPDATE_QUOTATION',
    // Payload
	id: id,
	checked: checked
  }
};

export const removeOrder = (id) => {
  return {
    type: 'REMOVE_ORDER',
	id: id,
  }
};
